module.exports = __webpack_public_path__ + "web/img/z3.32dcfb11.png";